import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { yandexMetrikaHit } from "../analytics/yandexMetrika";
import { captureAdAttributionFromUrl } from "../utils/adAttribution";

/**
 * Hit Метрики при SPA-навигации + захват yclid/UTM из URL.
 */
export default function YandexMetrikaTracker() {
  const location = useLocation();

  useEffect(() => {
    captureAdAttributionFromUrl(location.search);
    yandexMetrikaHit();
  }, [location.pathname, location.search]);

  return null;
}
